import { render, staticRenderFns } from "./AvatarSquare.vue?vue&type=template&id=b4e6810a"
import script from "./AvatarSquare.vue?vue&type=script&lang=js"
export * from "./AvatarSquare.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports